import type { AnalyzeFilter, House, ViabilityFilter } from "@/types";

export const queryKeys = {
  analyzes: ["analyzes"],
  analyze: (filter: AnalyzeFilter) => ["analyze", filter],
  registry: (filter: Pick<House, "banco" | "numero_do_leilao">) => [
    "registry",
    { filter },
  ],
  onboarding: ["onboarding"],
  favorites: ["favorites"],
  favorite: (id: string) => ["favorite", id],
  alerts: ["alerts"],
  alert: (id: string) => ["alert", id],
  viabilities: (filter?: ViabilityFilter) => ["viabilities", filter],
  viability: (id: string) => ["viability", id],
  subscriptionDiscount: ["subscription-discount"],
  propertiesUfCities: (uf: string) => ["properties-uf-cities", uf],
};
